import isNumeric from 'validator/es/lib/isNumeric';

import { ValidationError } from '@dte/otw-utils-validation/src/ValidationError';

import { validateRequiredString } from './validateString';

export function validateRequiredNumericString(
	name: string,
	value: string | number | undefined,
	minLength?: number,
	maxLength = 100,
	options?: validator.IsNumericOptions,
): string {
	const normalized = validateRequiredString(name, value?.toString(), minLength, maxLength);

	// Make sure it's a numeric value and exactly 10 digits
	if (!isNumeric(normalized, options)) {
		throw new ValidationError(`Invalid value: ${name} must be numeric`);
	}

	return normalized;
}

export function validateOptionalNumericString(
	name: string,
	value: string | number | undefined,
	minLength?: number,
	maxLength = 100,
	options?: validator.IsNumericOptions,
): string | undefined {
	try {
		return validateRequiredNumericString(name, value, minLength, maxLength, options);
	} catch (error) {
		// Allow for undefined values, but rethrow if an invalid value was provided
		if (value) {
			throw error;
		}
		return undefined;
	}
}

export function isValidNumericString(
	name: string,
	value: string | number | undefined,
	minLength?: number,
	maxLength = 100,
	options?: validator.IsNumericOptions,
): boolean {
	try {
		const validatedValue = validateRequiredNumericString(name, value, minLength, maxLength, options);
		return validatedValue !== undefined;
	} catch {
		return false;
	}
}
